// extracted by mini-css-extract-plugin
module.exports = {"container":"Container_container__2FGjI","full":"Container_full__2tLKc"};